import { colorsPalettes } from "@similarweb/styles";

import { CHART_COLORS } from "app/constants/ChartColors";
import { SourceType, sourceTypeTextKeys } from "app/UtilitiesAndConstants/Constants/SourceTypes";

export enum SourceTypes {
    TOTAL,
    ORGANIC,
    PAID,
}

export const sourceTypeSwitcherItems = [
    { id: SourceType.TOTAL, textKey: sourceTypeTextKeys[SourceType.TOTAL] },
    { id: SourceType.ORGANIC, textKey: sourceTypeTextKeys[SourceType.ORGANIC] },
    { id: SourceType.PAID, textKey: sourceTypeTextKeys[SourceType.PAID] },
];

export enum MetricTypes {
    KEYWORDS,
    VOLUME,
}

export const metricTypeSwitcherItems = [
    {
        id: MetricTypes.KEYWORDS,
        textKey: "common.keywords",
    },
    {
        id: MetricTypes.VOLUME,
        textKey: "common.volume",
    },
];

export const KEYWORDS_GAP_GRAPH_ENDPOINT = "api/WebsiteAnalysis/Overview/KeywordGap";
export const KEYWORDS_GAP_VALUE_KEY = "keywordsValue";
export const VOLUME_GAP_VALUE_KEY = "volumeValue";

export const COLORS_CONFIG = {
    intersection: new Map([
        ["0-1", "rgba(160, 105, 108, 0.2)"],
        ["0-2", "rgba(32, 141, 146, 0.2)"],
        ["1-2", "rgba(127, 163, 79, 0.2)"],
        ["0-1-2", "rgba(106, 136, 112, 0.2)"],
    ]),
    single: [colorsPalettes.sky[100], colorsPalettes.orange[100], colorsPalettes.torquoise[50]],
    border: CHART_COLORS.chartMainColors.slice(0, 3),
};

export const VENN_COLOR_KEY_DELIMITER = "-";
